import { render, staticRenderFns } from "./bestDeals.vue?vue&type=template&id=6f9938ba&scoped=true&"
import script from "./bestDeals.vue?vue&type=script&lang=js&"
export * from "./bestDeals.vue?vue&type=script&lang=js&"
import style0 from "./bestDeals.vue?vue&type=style&index=0&id=6f9938ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9938ba",
  null
  
)

export default component.exports